import { render, staticRenderFns } from "./NewsInformation.vue?vue&type=template&id=c274bc82&scoped=true&"
import script from "./NewsInformation.vue?vue&type=script&lang=js&"
export * from "./NewsInformation.vue?vue&type=script&lang=js&"
import style0 from "./NewsInformation.vue?vue&type=style&index=0&id=c274bc82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c274bc82",
  null
  
)

export default component.exports